import Vue from "vue";
import md5 from "md5";

Vue.prototype.$md5 = md5;

export default Vue;
